import React, {ComponentProps} from 'react'
import styled, {keyframes} from 'styled-components'

import {Text, themeGet} from '../..'
import Toast from './Toast'
import {
  ToastProps,
  ToastViewportProps,
  ToastProviderProps,
  ToastTitleProps,
  ToastDescriptionProps,
  ToastActionProps,
  ToastCloseProps
} from '.'

// styles
const hide = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`
const slideIn = keyframes`
  from {
    transform: translateX(calc(100% + var(--viewport-padding)));
  }
  to {
    transform: translateX(0);
  }
`
const swipeOut = keyframes`
  from {
    transform: translateX(var(--radix-toast-swipe-end-x));
  }
  to {
    transform: translateX(calc(100% + var(--viewport-padding)));
  }
`
export const StyledToastViewport = styled(Toast.Viewport)`
  --viewport-padding: ${themeGet('space.3')};
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: var(--viewport-padding);
  gap: ${themeGet('space.3')};
  width: 390px;
  max-width: 100vw;
  margin: 0;
  list-style: none;
  z-index: 2147483647;
  outline: none;
`
export const StyledToast = styled(Toast)`
  background-color: ${themeGet('colors.elevation.surface.default.[default]')};
  border-radius: ${themeGet('radii.2')};
  box-shadow: ${themeGet('shadows.elevation.shadow.overlay')};
  padding: ${themeGet('space.4')};
  display: grid;
  grid-template-areas: 'title action' 'description action';
  grid-template-columns: auto max-content;
  column-gap: ${themeGet('space.4')};
  align-items: center;
  border: 1px solid ${themeGet('colors.border.subtle')};

  &[data-state='open'] {
    animation: ${slideIn} 150ms cubic-bezier(0.16, 1, 0.3, 1);
  }
  &[data-state='closed'] {
    animation: hide 100ms ease-in;
  }
  &[data-swipe='move'] {
    transform: translateX(var(--radix-toast-swipe-move-x));
  }
  &[data-swipe='cancel'] {
    transform: translateX(0);
    transition: transform 200ms ease-out;
  }
  &[data-swipe='end'] {
    animation: ${swipeOut} 100ms ease-out;
  }
`
export const StyledToastTitle = styled(Toast.Title)`
  grid-area: title;
  margin-bottom: ${themeGet('space.2')};
  font-weight: ${themeGet('fontWeights.semibold')};
  color: ${themeGet('colors.text.default')};
  font-size: ${themeGet('fontSizes.3')};
`
export const StyledToastDescription = styled(Toast.Description)`
  grid-area: description;
  margin: 0;
  color: ${themeGet('colors.text.default')};
  font-size: ${themeGet('fontSizes.2')};
  line-height: ${themeGet('lineHeights.default')};
`
export const StyledToastAction = styled(Toast.Action)`
  grid-area: action;
`
export const StyledToastClose = styled(Toast.Close)`
  grid-area: action;
  // reset
  appearance: none;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  user-select: none;
  display: flex;
  align-items: center;
  color: inherit;
  margin-left: ${themeGet('space.4')};
  font-weight: normal;
  font-size: ${themeGet('fontSizes.2')};
  text-decoration: none;
  opacity: 0.85;
  font-weight: ${themeGet('fontWeights.semibold')};
  padding: ${themeGet('space.2')} 12px;
  border-radius: ${themeGet('radii.1')};
  &:hover {
    opacity: 1;
    text-decoration: none;
    color: ${themeGet('colors.link.default')};
    background-color: ${themeGet('colors.background.neutral.subtle.hovered')};
  }

  &:focus,
  .focus-visible {
    outline: none;
    transition-duration: 0s, 0.2s;
    box-shadow: 0 0 0 2px ${themeGet('colors.border.focused')};
  }
  &:focus:not(:focus-visible):not(.focus-visible) {
    box-shadow: 0 0 0 2px ${themeGet('colors.border.focused')};
  }
  svg {
    transition: transform 0.15s ease;
  }
`
